import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, SelectBox, Popup } from 'devextreme-react';
import { productPortfolioService } from '../services/product-portfolio-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { confirm } from 'devextreme/ui/dialog';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';

const ProductPortfolio = () => {

    let LocationCode: any;
    let SupplierCode: any;
    let CategoryCode: any;
    let ProductCode: any;

    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const [store, setStore] = useState<CustomStore>();
    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["locationCode", "productCode", "vendorCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        getvendorLookups()
        const x = await productPortfolioService.getOrderList(SupplierCode, LocationCode, CategoryCode, ProductCode);
        return x;
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedLocation = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        LocationCode = e.value;
        getsupplierLookups();
    }, []);

    const onValueChangedSupplier = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        SupplierCode = e.value;
    }, []);

    const onValueChangedCategory = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        CategoryCode = e.value;
    }, []);

    const onValueChangedProduct = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        ProductCode = e.value;
    }, []);

    const [locationLookups] = useState(new CustomStore({
        load: productPortfolioService.getLocationsLookup
    }));

    const [supplierLookups, setsupplierLookups] = useState();
    const getsupplierLookups = async () => {
        setsupplierLookups(await productPortfolioService.getSuppliersLookup(LocationCode))
    };


    const [vendorLookups, setvendorLookups] = useState();
    const getvendorLookups = async () => {
        setvendorLookups(await productPortfolioService.getlocation_suppliers())
    };

    const [categoryLookups] = useState(new CustomStore({
        load: productPortfolioService.getCategoriesLookup
    }));

    const [productLookups] = useState(new CustomStore({
        load: productPortfolioService.getProductsLookup
    }));

    const getFilteredVendors = (options: { data?: any }) => ({
        store: vendorLookups,
        filter: options.data ? [["productCode", "=", options.data.productCode], "and", ["locationCode", "=", options.data.locationCode]] : null
    });


    const onSave = async () => {
        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData();
                }
            });
        }
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            console.log(e.changes)
            productPortfolioService.updateProductPortfolio(e.changes).then((response) => {
                dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }

    const goToTransactions = (ProductCode: any, SupplierCode: any, LocationCode: any) => {
        productPortfolioService.getTransactions(ProductCode, SupplierCode, LocationCode).then(
            x => {
                setStoreVendorSummaries(x);
                showInfoTransactions(true);
            }
        );
    }

    const [popupVisibleTransactions, setPopupVisibleTransactions] = useState(false);
    const showInfoTransactions = useCallback((e: any) => {
        setPopupVisibleTransactions(true);
    }, [setPopupVisibleTransactions]);

    const hideInfoTransactions = useCallback(() => {
        setPopupVisibleTransactions(false);
    }, [setPopupVisibleTransactions]);

    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if (e.column.dataField === 'vendorCode' || e.column.dataField === 'isActive'
                || e.column.dataField === 'isSales' || e.column.dataField === 'isStockKept'
                || e.column.dataField === 'isOrder') {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6"> {t("syncflow:location")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="locationLookups"
                                dataSource={locationLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedLocation}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:supplier")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="supplierLookups"
                                dataSource={supplierLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedSupplier}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6"> {t("syncflow:lb_product_category")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="categoryLookups"
                                dataSource={categoryLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedCategory}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_product")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="productLookups"
                                dataSource={productLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedProduct}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={false}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    onCellPrepared={onCellPrepared}
                    onSaving={onSaving}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'locationCode',
                            caption: t('syncflow:lb_store_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible: false,
                        },
                        {
                            dataField: 'locationName',
                            caption: t('syncflow:location'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'categoryCode',
                            caption: t('syncflow:category_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible: false,
                        },
                        {
                            dataField: 'categoryName',
                            caption: t('syncflow:category_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'vendorCode',
                            caption: t('syncflow:lb_vendor_name'),
                            allowFiltering: true,
                            allowEditing: true,
                            customErrorMessage: t('syncflow:msg_reason_required'),
                            lookup: {
                                dataSource: getFilteredVendors,
                                valueExpr: "vendorCode",
                                displayExpr: "vendorName"
                            },
                        },
                        {
                            dataField: 'isActive',
                            caption: t('syncflow:is_active'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'isSales',
                            caption: t('syncflow:is_sales'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'isOrder',
                            caption: t('syncflow:is_order'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'isStockKept',
                            caption: t('syncflow:is_stock_kept'),
                            allowFiltering: true,
                            allowEditing: true,
                            // cellRender: (data: any) => {
                            //     let result = data.row.data;
                            //     return (
                            //         result.isStockKept ? t('syncflow:op_yes') : t('syncflow:op_no')
                            //     )
                            // },
                        },
                        {
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t('syncflow:changing_history')}
                                        type="default"
                                        stylingMode="contained"
                                        onClick={() => goToTransactions(data.key.productCode, data.key.vendorCode, data.key.locationCode)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>


            <Popup
                visible={popupVisibleTransactions}
                onHiding={hideInfoTransactions}
                title={t('syncflow:changing_history')}
                showTitle={true}
                width={1500}
                height={700}
                position={{ of: window, at: 'center', my: 'center' }}
            >


                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={false}
                    filterVisible={false}
                    headerFilterVisible={false}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,
                    }}
                    columns={[
                        {
                            dataField: 'vendorName',
                            caption: t('syncflow:lb_vendor_name'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'oldIsActive',
                            caption: t('syncflow:old_is_active'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'oldIsSales',
                            caption: t('syncflow:old_is_sales'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'oldIsOrder',
                            caption: t('syncflow:old_is_order'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'oldIsStockKept',
                            caption: t('syncflow:old_is_stock_kept'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'newIsActive',
                            caption: t('syncflow:is_active'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'newIsSales',
                            caption: t('syncflow:is_sales'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'newIsOrder',
                            caption: t('syncflow:is_order'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'newIsStockKept',
                            caption: t('syncflow:is_stock_kept'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                    ]}
                />

            </Popup>

        </>


    )
}
export default ProductPortfolio